import { Base64 } from 'js-base64'
import { throttle, debounce } from 'lodash'
import config from '@/utils/config'
import { waiting } from './data'

const title = config.title || '后台管理系统'

export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

export function generateTitle (title) {
  const hasKey = title
  if (hasKey) {
    const translatedTitle = title
    return translatedTitle
  }
  return title
}

export function getPageTitle (key) {
  const hasKey = `${key}`
  if (hasKey) {
    const pageName = `${key}`
    return `${pageName} - ${title}`
  }
  return `${title}`
}

export const treeFormat = (arr) => {
  if (!Array.isArray(arr)) return arr
  const newTree = []
  arr.map((el) => {
    if (el.child && el.child.length) {
      const childNode = treeFormat(el.child)
      newTree.push({
        ...el,
        checkAll: false,
        hasCheck: [],
        child: childNode
      })
    } else {
      newTree.push({
        ...el
      })
    }
  })
  return newTree
}

// 编辑角色权限列表
export const roleRules = (tree, rules) => {
  if (!rules || rules.length === 0) return [...tree]
  tree.forEach((el) => {
    if (el.child.length === 0 && rules.includes(el.id)) {
      el.checkAll = true
    }
    roleRules(el.child, rules)
  })

  return tree
}

/**
 * 防抖函数
 * @param {*} func 函数体
 * @param {*} wait 延时
 */
export const Debounce = (func, wait = waiting) => debounce(func, wait)

/**
 * 节流函数
 * @param {*} func 函数体
 * @param {*} wait 延时
 */
export const Throttle = (func, wait = waiting) => {
  return throttle(func, wait)
}

export function set_ (key, value) {
  console.log(key)
  console.log(value)
  window.sessionStorage.setItem(key, Base64.encode(value))
}

export function get_ (key) {
  return window.sessionStorage.getItem(key)
    ? Base64.decode(window.sessionStorage.getItem(key))
    : null
}

export function remove_ (key) {
  window.sessionStorage.removeItem(key)
}

export function getNextWord (key) {
  const code = key.charCodeAt() + 1 // 65
  return String.fromCharCode(code) // A
}

export function downloadExcel (url) {
  const a = document.createElement('a')
  a.href = url
  a.click()
}
